// Generated by purs version 0.15.0
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Boolean from "../Data.Boolean/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Functor_Extra from "../Data.Functor.Extra/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_Record_Extra2 from "../Data.Record.Extra2/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_String_CodeUnits from "../Data.String.CodeUnits/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Effect_Aff from "../Effect.Aff/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Foreign_Object from "../Foreign.Object/index.js";
import * as Record from "../Record/index.js";
import * as Record_Extra from "../Record.Extra/index.js";
import * as Restaumatic_I18n from "../Restaumatic.I18n/index.js";
import * as Restaumatic_OldForm from "../Restaumatic.OldForm/index.js";
import * as Restaumatic_Order_Types from "../Restaumatic.Order.Types/index.js";
import * as Restaumatic_Order_User from "../Restaumatic.Order.User/index.js";
import * as Restaumatic_Site_RPC from "../Restaumatic.Site.RPC/index.js";
import * as Restaumatic_Site_Translations_Keys from "../Restaumatic.Site.Translations.Keys/index.js";
import * as Restaumatic_Storage from "../Restaumatic.Storage/index.js";
import * as Specular_Dom_Builder from "../Specular.Dom.Builder/index.js";
import * as Specular_Dom_Builder_Class from "../Specular.Dom.Builder.Class/index.js";
import * as Specular_Dom_Element from "../Specular.Dom.Element/index.js";
import * as Specular_Dom_Extra from "../Specular.Dom.Extra/index.js";
import * as Specular_Dom_Widget from "../Specular.Dom.Widget/index.js";
import * as Specular_Extra_Attr from "../Specular.Extra.Attr/index.js";
import * as Specular_Extra_Switch from "../Specular.Extra.Switch/index.js";
import * as Specular_FRP_Base from "../Specular.FRP.Base/index.js";
import * as Type_Equality from "../Type.Equality/index.js";
import * as Type_Proxy from "../Type.Proxy/index.js";
import * as Utils_DynamicFixFRP from "../Utils.DynamicFixFRP/index.js";
var validateFullName = function (fullName) {
    if (fullName === "") {
        return new Restaumatic_OldForm["Error"](Restaumatic_I18n.translate_(Restaumatic_Site_Translations_Keys.t.errors.messages.blank));
    };
    if (!Restaumatic_Order_User.isFullNameValid(fullName)) {
        return new Restaumatic_OldForm["Error"](Restaumatic_I18n.translate_(Restaumatic_Site_Translations_Keys.t.errors.messages.invalid));
    };
    if (Data_Boolean.otherwise) {
        return Restaumatic_OldForm.Success.value;
    };
    throw new Error("Failed pattern match at Restaumatic.Site.Components.User (line 203, column 1 - line 203, column 53): " + [ fullName.constructor.name ]);
};
var validateEmail = function (email) {
    if (email === "") {
        return Control_Applicative.pure(Effect_Aff.applicativeAff)(new Restaumatic_OldForm["Error"](new Restaumatic_OldForm.ErrorText(Restaumatic_I18n.translate_(Restaumatic_Site_Translations_Keys.t.errors.messages.blank))));
    };
    if (!Restaumatic_Order_User.isEmailSyntaxValid(email)) {
        return Control_Applicative.pure(Effect_Aff.applicativeAff)(new Restaumatic_OldForm["Error"](new Restaumatic_OldForm.ErrorText(Restaumatic_I18n.translate_(Restaumatic_Site_Translations_Keys.t.errors.messages.invalid))));
    };
    if (Data_Boolean.otherwise) {
        return Control_Applicative.pure(Effect_Aff.applicativeAff)(Restaumatic_OldForm.Success.value);
    };
    throw new Error("Failed pattern match at Restaumatic.Site.Components.User (line 239, column 1 - line 239, column 62): " + [ email.constructor.name ]);
};
var userKey = "user";
var toStoredUser = function (x) {
    return {
        email: new Data_Maybe.Just(x.email),
        fullName: new Data_Maybe.Just(x.fullName),
        parsedPhone: new Data_Maybe.Just(x.phone)
    };
};
var phoneField = function (country) {
    return function (initialValue) {
        return function (shouldLock) {
            var validate = function (v) {
                if (v === "") {
                    return Control_Applicative.pure(Effect_Aff.applicativeAff)(new Restaumatic_OldForm["Error"](Restaumatic_I18n.translate_(Restaumatic_Site_Translations_Keys.t.errors.messages.blank)));
                };
                return Control_Bind.bind(Effect_Aff.bindAff)(Restaumatic_Site_RPC.checkPhone(Data_Newtype.wrap()({
                    country: country,
                    phone: v
                })))(function (result) {
                    return Control_Applicative.pure(Effect_Aff.applicativeAff)((function () {
                        if (result instanceof Data_Either.Right && result.value0) {
                            return Restaumatic_OldForm.Success.value;
                        };
                        if (result instanceof Data_Either.Right && !result.value0) {
                            return new Restaumatic_OldForm["Error"](Restaumatic_I18n.translate_(Restaumatic_Site_Translations_Keys.t.activerecord.errors.models.order.attributes.user.attributes.parsed_phone.invalid));
                        };
                        if (result instanceof Data_Either.Left) {
                            return new Restaumatic_OldForm["Error"]("Error validating phone");
                        };
                        throw new Error("Failed pattern match at Restaumatic.Site.Components.User (line 273, column 14 - line 279, column 41): " + [ result.constructor.name ]);
                    })());
                });
            };
            var fieldFunction = function (config) {
                return Specular_Extra_Switch.dynamicSwitch(Specular_Extra_Switch.switchRecordI(Specular_Extra_Switch.switchRecordCons({
                    reflectSymbol: function () {
                        return "event";
                    }
                })()()(Specular_Extra_Switch.switchEvent)(Specular_Extra_Switch.switchRecordCons({
                    reflectSymbol: function () {
                        return "value";
                    }
                })()()(Specular_Extra_Switch.switchDynamic)(Specular_Extra_Switch.switchRecordNil(Type_Equality.refl))())())())(Specular_Dom_Builder.monadReplaceBuilder)(Specular_FRP_Base.monadFRP(Specular_Dom_Builder.monadEffectBuilder)(Specular_Dom_Builder.monadCleanupBuilder))(Data_Functor.mapFlipped(Specular_FRP_Base.functorDynamic)(shouldLock)(function (v) {
                    if (v) {
                        return Restaumatic_OldForm.textFieldLock(Restaumatic_OldForm.renderErrorString)(config);
                    };
                    return Data_Functor.map(Specular_Dom_Builder.functorBuilder)(Record.insert({
                        reflectSymbol: function () {
                            return "event";
                        }
                    })()()(Type_Proxy["Proxy"].value)(Specular_FRP_Base.never))(Restaumatic_OldForm.textField(Restaumatic_OldForm.renderErrorString)(config));
                }));
            };
            var view = function (validationState) {
                return Specular_Dom_Widget.liftWidget(Specular_Dom_Builder.monadDomBuilderBuilder)(fieldFunction({
                    name: "phone",
                    label: Restaumatic_I18n.translate_(Restaumatic_Site_Translations_Keys.t.activerecord.attributes.user.phone),
                    attrs: Data_Semigroup.append(Foreign_Object.semigroupObject(Data_Semigroup.semigroupString))(Specular_Extra_Attr.attr(Specular_Extra_Attr.attrStringAttrs)("autocomplete")("tel"))(Specular_Dom_Extra.testId(Specular_Dom_Extra.testIdLegacyAdapterAttrs)("user/phone")),
                    initialValue: initialValue,
                    required: true,
                    validationState: validationState,
                    autoFormat: Data_Maybe.Nothing.value
                }));
            };
            return Control_Bind.bind(Specular_Dom_Builder.bindBuilder)(Restaumatic_OldForm.fieldWithValidation()(Data_Eq.eqString)(validate)(view))(function (v) {
                return Control_Applicative.pure(Specular_Dom_Builder.applicativeBuilder)({
                    valid: Data_Functor.map(Specular_FRP_Base.functorDynamic)(Data_Functor.map(Data_Maybe.functorMaybe)(Restaumatic_Order_Types.Phone))(v.valid),
                    raw: v.raw,
                    changeAttempt: v.event
                });
            });
        };
    };
};
var fullNameField = function (initialValue) {
    var view = function (validationState) {
        return Specular_Dom_Widget.liftWidget(Specular_Dom_Builder.monadDomBuilderBuilder)(Restaumatic_OldForm.textField(Restaumatic_OldForm.renderErrorString)({
            name: "full-name",
            label: Restaumatic_I18n.translate_(Restaumatic_Site_Translations_Keys.t.activerecord.attributes.user.full_name),
            attrs: Data_Semigroup.append(Foreign_Object.semigroupObject(Data_Semigroup.semigroupString))(Specular_Extra_Attr.attr(Specular_Extra_Attr.attrStringAttrs)("autocomplete")("name"))(Specular_Dom_Extra.testId(Specular_Dom_Extra.testIdLegacyAdapterAttrs)("user/fullName")),
            initialValue: initialValue,
            required: true,
            validationState: validationState,
            autoFormat: Data_Maybe.Nothing.value
        }));
    };
    return Restaumatic_OldForm.fieldWithValidation()(Data_Eq.eqString)((function () {
        var $41 = Control_Applicative.pure(Effect_Aff.applicativeAff);
        return function ($42) {
            return $41(validateFullName($42));
        };
    })())(view);
};
var fromStoredUser = function (x) {
    return {
        email: Data_Maybe.fromMaybe("")(x.email),
        fullName: Data_Maybe.fromMaybe("")(x.fullName),
        phone: Data_Maybe.fromMaybe("")(x.parsedPhone)
    };
};
var formControl = function (dictMonadFRP) {
    return function (dictMonadReader) {
        return function (config) {
            return function (v) {
                return Control_Bind.bind(((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1())(Specular_FRP_Base.holdDyn(dictMonadFRP)(false)(Data_Functor.voidRight(Specular_FRP_Base.functorEvent)(true)(v.fieldChangeAttempt)))(function (showFodAlert) {
                    return Control_Applicative.pure(((dictMonadFRP.MonadCleanup1()).Monad0()).Applicative0())(new Data_Tuple.Tuple({
                        showFodAlert: showFodAlert
                    }, v));
                });
            };
        };
    };
};
var fodAlert = /* #__PURE__ */ (function () {
    var raquo = Specular_Dom_Builder_Class.rawHtml(Specular_Dom_Builder.monadDomBuilderBuilder)("&raquo;");
    var nbsp = Specular_Dom_Builder_Class.rawHtml(Specular_Dom_Builder.monadDomBuilderBuilder)("&nbsp;");
    return Specular_Dom_Element.el("div")([ Specular_Dom_Element.class_("animated fadeIn alert alert-info"), Specular_Dom_Element.attr("role")("alert") ])(Control_Bind.discard(Control_Bind.discardUnit)(Specular_Dom_Builder.bindBuilder)(Specular_Dom_Element.el_("strong")(Specular_Dom_Element.text(Restaumatic_I18n.translate_(Restaumatic_Site_Translations_Keys.t.first_order_discount.validation.alert.warning))))(function () {
        return Control_Bind.discard(Control_Bind.discardUnit)(Specular_Dom_Builder.bindBuilder)(nbsp)(function () {
            return Control_Bind.discard(Control_Bind.discardUnit)(Specular_Dom_Builder.bindBuilder)(Specular_Dom_Element.text(Restaumatic_I18n.translate_(Restaumatic_Site_Translations_Keys.t.first_order_discount.validation.alert.content)))(function () {
                return Control_Bind.discard(Control_Bind.discardUnit)(Specular_Dom_Builder.bindBuilder)(nbsp)(function () {
                    return Control_Bind.bind(Specular_Dom_Builder.bindBuilder)(Specular_Dom_Element["el$prime"]("a")([ Specular_Dom_Element.class_("alert-link"), Specular_Dom_Element.attr("href")("#") ])(Control_Bind.discard(Control_Bind.discardUnit)(Specular_Dom_Builder.bindBuilder)(Specular_Dom_Element.text(Restaumatic_I18n.translate_(Restaumatic_Site_Translations_Keys.t.first_order_discount.validation.alert.confirm)))(function () {
                        return Control_Bind.discard(Control_Bind.discardUnit)(Specular_Dom_Builder.bindBuilder)(nbsp)(function () {
                            return raquo;
                        });
                    })))(function (v) {
                        return Specular_Dom_Builder_Class.domEvent(Specular_FRP_Base.monadFRP(Specular_Dom_Builder.monadEffectBuilder)(Specular_Dom_Builder.monadCleanupBuilder))("click")(v.value0);
                    });
                });
            });
        });
    }));
})();
var emptyRawUser = {
    email: "",
    fullName: "",
    phone: ""
};
var emailField = function (initialValue) {
    return function (shouldLock) {
        var removeSpaces = (function () {
            var $43 = Data_Array.filter(function (x) {
                return x !== " ";
            });
            return function ($44) {
                return Data_String_CodeUnits.fromCharArray($43(Data_String_CodeUnits.toCharArray($44)));
            };
        })();
        var fieldFunction = function (config) {
            return Specular_Extra_Switch.dynamicSwitch(Specular_Extra_Switch.switchRecordI(Specular_Extra_Switch.switchRecordCons({
                reflectSymbol: function () {
                    return "event";
                }
            })()()(Specular_Extra_Switch.switchEvent)(Specular_Extra_Switch.switchRecordCons({
                reflectSymbol: function () {
                    return "value";
                }
            })()()(Specular_Extra_Switch.switchDynamic)(Specular_Extra_Switch.switchRecordNil(Type_Equality.refl))())())())(Specular_Dom_Builder.monadReplaceBuilder)(Specular_FRP_Base.monadFRP(Specular_Dom_Builder.monadEffectBuilder)(Specular_Dom_Builder.monadCleanupBuilder))(Data_Functor.mapFlipped(Specular_FRP_Base.functorDynamic)(shouldLock)(function (v) {
                if (v) {
                    return Restaumatic_OldForm.textFieldLock(Restaumatic_OldForm.renderErrorErrorContent)(config);
                };
                return Data_Functor.map(Specular_Dom_Builder.functorBuilder)(Record.insert({
                    reflectSymbol: function () {
                        return "event";
                    }
                })()()(Type_Proxy["Proxy"].value)(Specular_FRP_Base.never))(Restaumatic_OldForm.textField(Restaumatic_OldForm.renderErrorErrorContent)(config));
            }));
        };
        var view = function (validationState) {
            return Specular_Dom_Widget.liftWidget(Specular_Dom_Builder.monadDomBuilderBuilder)(fieldFunction({
                name: "email",
                label: Restaumatic_I18n.translate_(Restaumatic_Site_Translations_Keys.t.activerecord.attributes.user.email),
                attrs: Data_Semigroup.append(Foreign_Object.semigroupObject(Data_Semigroup.semigroupString))(Specular_Extra_Attr.attr(Specular_Extra_Attr.attrStringAttrs)("autocomplete")("email"))(Specular_Dom_Extra.testId(Specular_Dom_Extra.testIdLegacyAdapterAttrs)("user/email")),
                initialValue: initialValue,
                required: true,
                validationState: validationState,
                autoFormat: new Data_Maybe.Just(removeSpaces)
            }));
        };
        return Control_Bind.bind(Specular_Dom_Builder.bindBuilder)(Restaumatic_OldForm.fieldWithValidation()(Data_Eq.eqString)(validateEmail)(view))(function (v) {
            return Control_Applicative.pure(Specular_Dom_Builder.applicativeBuilder)({
                valid: Data_Functor.map(Specular_FRP_Base.functorDynamic)(Data_Functor.map(Data_Maybe.functorMaybe)(function ($45) {
                    return Restaumatic_Order_Types.Email.create(removeSpaces($45));
                }))(v.valid),
                raw: Data_Functor.map(Specular_FRP_Base.functorDynamic)(removeSpaces)(v.raw),
                changeAttempt: v.event
            });
        });
    };
};
var formView = function (config) {
    return function (initial) {
        return function (ctrl) {
            return Control_Bind.bind(Specular_Dom_Builder.bindBuilder)((function () {
                if (config.isQrWaiterOrder) {
                    return Control_Applicative.pure(Specular_Dom_Builder.applicativeBuilder)({
                        valid: Control_Applicative.pure(Specular_FRP_Base.applicativeDynamic)(new Data_Maybe.Just(Data_Maybe.Nothing.value)),
                        raw: Control_Applicative.pure(Specular_FRP_Base.applicativeDynamic)("")
                    });
                };
                return Control_Bind.bind(Specular_Dom_Builder.bindBuilder)(fullNameField(initial.fullName))(function (x) {
                    return Control_Applicative.pure(Specular_Dom_Builder.applicativeBuilder)({
                        valid: Data_Functor_Extra.composeMap(Specular_FRP_Base.functorDynamic)(Data_Maybe.functorMaybe)(Data_Maybe.Just.create)(x.valid),
                        raw: x.raw
                    });
                });
            })())(function (fullName) {
                return Control_Bind.bind(Specular_Dom_Builder.bindBuilder)((function () {
                    if (config.isQrWaiterOrder) {
                        return Control_Applicative.pure(Specular_Dom_Builder.applicativeBuilder)({
                            valid: Control_Applicative.pure(Specular_FRP_Base.applicativeDynamic)(new Data_Maybe.Just(Data_Maybe.Nothing.value)),
                            raw: Control_Applicative.pure(Specular_FRP_Base.applicativeDynamic)(""),
                            changeAttempt: Specular_FRP_Base.never
                        });
                    };
                    return Control_Bind.bind(Specular_Dom_Builder.bindBuilder)(phoneField(config.country)(initial.phone)(config.lockDataChange))(function (x) {
                        return Control_Applicative.pure(Specular_Dom_Builder.applicativeBuilder)({
                            valid: Data_Functor_Extra.composeMap(Specular_FRP_Base.functorDynamic)(Data_Maybe.functorMaybe)(Data_Maybe.Just.create)(x.valid),
                            changeAttempt: x.changeAttempt,
                            raw: x.raw
                        });
                    });
                })())(function (phone) {
                    return Control_Bind.bind(Specular_Dom_Builder.bindBuilder)((function () {
                        if (config.requireEmail) {
                            return emailField(initial.email)(config.lockDataChange);
                        };
                        return Control_Applicative.pure(Specular_Dom_Builder.applicativeBuilder)({
                            valid: Control_Applicative.pure(Specular_FRP_Base.applicativeDynamic)(new Data_Maybe.Just(new Restaumatic_Order_Types.Email(initial.email))),
                            raw: Control_Applicative.pure(Specular_FRP_Base.applicativeDynamic)(initial.email),
                            changeAttempt: Specular_FRP_Base.never
                        });
                    })())(function (email) {
                        return Control_Bind.bind(Specular_Dom_Builder.bindBuilder)(Specular_Dom_Widget.liftWidget(Specular_Dom_Builder.monadDomBuilderBuilder)(Specular_Dom_Extra.actionVisibleIfDyn(ctrl.showFodAlert)(fodAlert)))(function (unlockUserDataE) {
                            return Control_Applicative.pure(Specular_Dom_Builder.applicativeBuilder)({
                                user: {
                                    valid: Data_Record_Extra2.rsequence2(Specular_FRP_Base.functorDynamic)()(Data_Maybe.applicativeMaybe)(Record_Extra.sequenceRecordCons({
                                        reflectSymbol: function () {
                                            return "email";
                                        }
                                    })()(Data_Maybe.applyMaybe)(Record_Extra.sequenceRecordCons({
                                        reflectSymbol: function () {
                                            return "fullName";
                                        }
                                    })()(Data_Maybe.applyMaybe)(Record_Extra.sequenceRecordSingle({
                                        reflectSymbol: function () {
                                            return "phone";
                                        }
                                    })()(Data_Maybe.functorMaybe)()())()())()())()(Specular_FRP_Base.applicativeDynamic)(Record_Extra.sequenceRecordCons({
                                        reflectSymbol: function () {
                                            return "email";
                                        }
                                    })()(Specular_FRP_Base.applyDynamic)(Record_Extra.sequenceRecordCons({
                                        reflectSymbol: function () {
                                            return "fullName";
                                        }
                                    })()(Specular_FRP_Base.applyDynamic)(Record_Extra.sequenceRecordSingle({
                                        reflectSymbol: function () {
                                            return "phone";
                                        }
                                    })()(Specular_FRP_Base.functorDynamic)()())()())()())({
                                        email: email.valid,
                                        phone: phone.valid,
                                        fullName: fullName.valid
                                    }),
                                    raw: Data_Record_Extra2.rsequence()(Specular_FRP_Base.applicativeDynamic)(Record_Extra.sequenceRecordCons({
                                        reflectSymbol: function () {
                                            return "email";
                                        }
                                    })()(Specular_FRP_Base.applyDynamic)(Record_Extra.sequenceRecordCons({
                                        reflectSymbol: function () {
                                            return "fullName";
                                        }
                                    })()(Specular_FRP_Base.applyDynamic)(Record_Extra.sequenceRecordSingle({
                                        reflectSymbol: function () {
                                            return "phone";
                                        }
                                    })()(Specular_FRP_Base.functorDynamic)()())()())()())({
                                        email: email.raw,
                                        phone: phone.raw,
                                        fullName: fullName.raw
                                    })
                                },
                                unlockUserData: unlockUserDataE,
                                fieldChangeAttempt: Specular_FRP_Base.leftmost([ email.changeAttempt, phone.changeAttempt ])
                            });
                        });
                    });
                });
            });
        };
    };
};
var userForm = function (config) {
    return function (initial) {
        return Utils_DynamicFixFRP.dynamicFixFRP(Utils_DynamicFixFRP.fixFRPRecord(Utils_DynamicFixFRP.dynamicFixFRPRecord({
            reflectSymbol: function () {
                return "showFodAlert";
            }
        })()()()()(Utils_DynamicFixFRP.dynamicFixFRPDynamic)(Utils_DynamicFixFRP.dynamicFixFRPRecordNil(Type_Equality.refl)))())(Specular_FRP_Base.monadFRP(Specular_Dom_Builder.monadEffectBuilder)(Specular_Dom_Builder.monadCleanupBuilder))({
            showFodAlert: false
        })(Control_Bind.composeKleisli(Specular_Dom_Builder.bindBuilder)(formView(config)(initial))(formControl(Specular_FRP_Base.monadFRP(Specular_Dom_Builder.monadEffectBuilder)(Specular_Dom_Builder.monadCleanupBuilder))(Specular_Dom_Builder.monadReaderBuilder)(config)));
    };
};
var userFormWithPersistence = function (config) {
    return Control_Bind.bind(Specular_Dom_Builder.bindBuilder)(Data_Functor.map(Specular_Dom_Builder.functorBuilder)((function () {
        var $46 = Data_Maybe.fromMaybe(emptyRawUser);
        var $47 = Data_Functor.map(Data_Maybe.functorMaybe)(fromStoredUser);
        return function ($48) {
            return $46($47($48));
        };
    })())(Restaumatic_Storage.readStoredValue(Foreign_Generic_Class.recordDecode()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "parsedPhone";
        }
    })(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.maybeDecode(Foreign_Generic_Class.stringDecode)))())({
        reflectSymbol: function () {
            return "fullName";
        }
    })(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.maybeDecode(Foreign_Generic_Class.stringDecode)))())({
        reflectSymbol: function () {
            return "email";
        }
    })(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.maybeDecode(Foreign_Generic_Class.stringDecode)))()))(Specular_Dom_Builder.monadReaderBuilder)(Specular_Dom_Builder.monadEffectBuilder)(userKey)))(function (v) {
        return Control_Bind.bind(Specular_Dom_Builder.bindBuilder)(userForm(config)(v))(function (v1) {
            return Control_Bind.discard(Control_Bind.discardUnit)(Specular_Dom_Builder.bindBuilder)(Restaumatic_Storage.storeValue(Foreign_Generic_Class.recordEncode()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
                reflectSymbol: function () {
                    return "parsedPhone";
                }
            })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.maybeEncode(Foreign_Generic_Class.stringEncode))))({
                reflectSymbol: function () {
                    return "fullName";
                }
            })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.maybeEncode(Foreign_Generic_Class.stringEncode))))({
                reflectSymbol: function () {
                    return "email";
                }
            })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.maybeEncode(Foreign_Generic_Class.stringEncode)))))(Specular_Dom_Builder.monadReaderBuilder)(Specular_FRP_Base.monadFRP(Specular_Dom_Builder.monadEffectBuilder)(Specular_Dom_Builder.monadCleanupBuilder))(userKey)(Data_Functor.map(Specular_FRP_Base.functorEvent)(toStoredUser)(Specular_FRP_Base.changed(v1.user.raw))))(function () {
                return Control_Applicative.pure(Specular_Dom_Builder.applicativeBuilder)({
                    user: v1.user.valid,
                    unlockUserData: v1.unlockUserData
                });
            });
        });
    });
};
export {
    userFormWithPersistence,
    userForm,
    userKey,
    emptyRawUser,
    toStoredUser,
    fromStoredUser,
    emailField
};
//# sourceMappingURL=index.js.map
